/**
 * How long a slide stays on screen when nobody has said otherwise. The browser
 * half of `api/src/shared/defaults.ts` — the two are separate bundles, so the
 * constant is stated twice and must be changed together.
 */
export const DEFAULT_SLIDE_SECONDS = 15;
